import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import app from './base/api';

import Login from './pages/Login';
import AppContainer from './tools/AppContainer';
import Home from './pages/Home';

import PrivateRoute from './utils/PrivateRoute';
import PublicRoute from './utils/PublicRoute';
import { getToken, removeUserSession, setUserSession } from './utils/Common';

class App extends React.Component {

  async componentDidMount () {
    const token = getToken();
    if (!token) {
      return;
    }

    let res = await app.get('/current_user');
    if (res && res.id) {
      setUserSession(res.id, res);
    } else {
      removeUserSession();
    }
  }

  render () {
    return (
    <div className="App">
      <BrowserRouter>
        <div>
          <div className="">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
              <Route path="/dashboard/*" element={<PrivateRoute><AppContainer /></PrivateRoute>} />
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    </div>
    );
  }
}

export default App;
